import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTemp } from 'swipeclock-frontend';
import ErrorIcon from '@mui/icons-material/Error';
import { useCountdown } from '../hooks/useTimer';
import { useTheme } from '@mui/material/styles';
import PoweredByFooter from './shared/PoweredByFooter';

// Shared components
import PromptContentCard from './shared/PromptContentCard';
import ActionButton from './shared/ActionButton';
import {
  HeaderStack,
  CountdownProgress,
  TimerText,
  TitleText,
  MessageText,
} from './shared/PromptStyled';
import { useWhiteLabelContext } from 'providers/WhiteLabelProvider';

export default function PromptFailure() {
  const history = useHistory();
  const theme = useTheme();
  const { state: whiteLabelState } = useWhiteLabelContext();

  // Redirects to the clock page after 20 seconds
  const { timeLeft, progressPercentage } = useCountdown(20, () =>
    history.push('/clock/web')
  );

  return (
    <>
      <PromptContentCard
        accentColor={{
          main: theme.palette.error.main,
          light: theme.palette.error.light,
        }}
      >
        <Prompt />
        <CountdownProgress
          variant="determinate"
          value={progressPercentage}
          color={{ main: '#f44336', light: '#f44336' }}
        />
        <TimerText variant="caption">{timeLeft}s</TimerText>
      </PromptContentCard>
      <PoweredByFooter whiteLabelState={whiteLabelState} />
    </>
  );
}

// #########################
// ### Child Components ###
// #########################

const Prompt = React.memo(function Prompt() {
  const { temp: cache } = useTemp('webClock');

  const { error } = cache || {};
  const title = 'Unable to Process Request';
  const message =
    error ||
    'There was an error processing your punch request. Please try again or contact your administrator.';

  return (
    <>
      <HeaderStack>
        <ErrorIcon fontSize="large" sx={{ color: '#f44336' }} />
        <TitleText variant="h4">{title}</TitleText>
      </HeaderStack>
      <MessageText variant="h5">{message}</MessageText>
      <ActionButton
        id="sc-failure_return_to_clock_button"
        to="/clock/web"
        color={{ dark: '#d32f2f', main: '#f44336' }}
      >
        RETURN TO CLOCK
      </ActionButton>
    </>
  );
});
